import { Injectable } from '@angular/core';

export interface SDKToken {
  userId: number;
}

@Injectable()
export class ApiAuth {
  protected prefix = '';

  private currentUserId: number;

  public setUser(user: { id: number }) {
    this.currentUserId = user ? user.id : null;
  }

  public setToken(token: SDKToken): void {
    this.currentUserId = token.userId;
    // Leave void
    // Frontend doesn't take care of the authentication cookies
    // Api does
  }

  public getCurrentUserId(): any {
    return this.currentUserId;
  }

  public clear(): void {
    // Leave void
    // Frontend doesn't take care of the authentication cookies
    // Api does
  }

  //#region Not implemented
  public getAccessTokenId(): string {
    throw new Error('Not implemented');
  }

  public setRememberMe(value: boolean): void {
    throw new Error('Not implemented');
  }

  public getToken(): SDKToken {
    throw new Error('Not implemented');
  }

  public getCurrentUserData(): any {
    throw new Error('Not implemented');
  }

  public save(): boolean {
    throw new Error('Not implemented');
  }

  protected load(prop: string): any {
    throw new Error('Not implemented');
  }

  protected persist(prop: string, value: any, expires?: Date): void {
    throw new Error('Not implemented');
  }
  //#endregion
}
